import React, { useEffect } from 'react';
import { trackEvent } from '../../utils/analytics';
import styles from './SuccessPage.module.scss';
import BrandrLogo from '../../assets/logo/Brandr_Logo.svg';

const SuccessPage = ({ title, subtitle }) => {
  useEffect(() => {
    trackEvent('view_success_page', { title });
  }, [title]);

  return (
    <div className={styles.thankYouContainer}>
      <img src={BrandrLogo} alt="Brandr Logo" className={styles.logo} />
      <div className={styles.messageContainer}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};

export default SuccessPage;
